// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2-8Cq","content":"Consent_content__3njrv","footer":"Consent_footer__1xahB"};